<template>
  <div id="app">
    <header>
      <img src="./assets/logo.png" alt="River City Pawn logo" class="logo" />
      <h2 class="title">{{ msg }}</h2>
    </header>
    <div id="passwordVerification">
      <label for="lock" class="lock-label">Enter Password:</label>
      <input id="lock" placeholder="password" @input="verifyPassword" />
    </div>
    <div class="container" v-if="key">
      <div class="row">
        <div class="col-md-12">
          <diamond-form></diamond-form>
        </div>
      </div>
    </div>
    <footer>
      <span class="version">{{ ver }}</span>
    </footer>
  </div>
</template>

<script>
// import DiamondForm from "./components/DiamondForm.vue";
export default {
  name: "app",
  data() {
    return {
      key: false,
      msg: "Calculator",
      ver: "v1.0.0"
    };
  },
  methods: {
    verifyPassword(event) {
      if (event.target.value === "RCP2019") {
        this.key = true;
        document.getElementById("passwordVerification").classList.add("d-none");
        event.target.value = "";
      }
    }
  }
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
header {
  padding: 1rem 0;
  margin-bottom: 2rem;
  background-color: #f5f4f3;
  text-align: center;
}
.logo {
  width: 260px;
}
#passwordVerification {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
h1,
h2 {
  font-weight: normal;
  margin: 0;
}
footer {
  background-color: #f5f4f3;
  padding: 1rem 0;
  margin-top: 2rem;
  text-align: center;
}
.version {
  padding: 1rem;
}
.highlighted {
  background-color: yellow;
  font-weight: 600;
  display: inline-block;
  margin-bottom: 1rem;
}
.row {
  padding: 0;
  margin: 0;
}
label,
input {
  display: block;
}
label {
  text-align: left;
  font-size: 1.15rem;
  font-weight: 600;
  padding-right: 1rem;
  margin: 0;
}
input {
  padding-left: 1rem;
}
.diamond_subtotal {
  font-size: 1.5rem;
  text-align: left;
  margin-top: 2rem;
}
.bg-green {
  background-color: #92d050;
}
.bg-yellow {
  background-color: #ffff00;
}
.bg-red {
  background-color: #ff6600;
}
td {
  border-left: 1px dotted #b3b3b3;
}
</style>
